import { IAddElementTemplateToJobFormData, IAddElementTemplateToJobPayload } from 'elements/types';

export const mapAddElementTemplateToJobData = (
  data: IAddElementTemplateToJobFormData,
  elementTemplateId: number
): IAddElementTemplateToJobPayload => ({
  data: {
    elementTemplateId,
    jobName: data.jobName,
    name: data.name,
    projectId: data.project.id,
    quantity: data.quantity,
  },
});
